import { PartnerSearch } from '../../partner/models';
import { DataGroupDistributionObject } from './';

export class DataGroupPresentation {
    Id: number;
    Name: string;
    Description: string;
    DataGroupType: string;
    Partners: PartnerSearch[];
    DistributionObjectConnections: DataGroupDistributionObject[];
    CreatedDate: Date;
    CreatedBy: number;
    UpdatedDate: Date;
    UpdatedBy: number;
}
